import React from "react";
import { ExerciseCard } from "../../components/ExerciseCard";
import { mockPratiquerExercises } from "../../modules/exercises.mock";

// Play · Entraînements : reprises des exercices mockés en mode parcours court.
export default function PlayEntrainements() {
  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Play · Entraînements</h1>
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
          Des entraînements courts pour pratiquer régulièrement. Les cartes ci-dessous sont des prototypes.
        </p>
      </header>

      <section className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {mockPratiquerExercises.map((ex) => (
          <ExerciseCard key={ex.id} exercise={ex} />
        ))}
      </section>
    </div>
  );
}
